// extracted by mini-css-extract-plugin
var _1 = "is-disabled";
var _2 = "is-invalid";
var _3 = "rds-Textarea_1";
var _4 = "rds-Textarea--lg_1";
var _5 = "rds-Textarea--sm_1";
var _6 = "rds-Textarea-counter_1";
export { _1 as "is-disabled", _2 as "is-invalid", _3 as "rds-Textarea", _4 as "rds-Textarea--lg", _5 as "rds-Textarea--sm", _6 as "rds-Textarea-counter" }
